module.exports = __webpack_public_path__ + "static/p1-2732567c8533f0301fd62f525416ceae.jpg";